import SSEConstant from "../const/SSEConstant";
import {isnull, showHangUp} from "../../utils/tools";
import {loge, log} from "../../utils/devext";
import EventBusConstant from "../const/EventBusConstant";
import global from "../../config/global";

export default class SSEO2OListener {

  cName = "PP_SseO2ODelegate"

  constructor(vueObj) {
    this.pageTarget = vueObj
  }

  onReceivePush(pushRsp) {
    switch (pushRsp.subCode) {
      case SSEConstant.OpO2O.userCall :
        this.onUserCall(pushRsp)
        break
      case SSEConstant.OpO2O.receiveRefuse :
        this.onReceiveRefuse(pushRsp)
        break
      case SSEConstant.OpO2O.receiveAnchorEnter:
      case SSEConstant.OpO2O.receiveUserEnter :
        this.onUserEnterRoom(pushRsp)
        break
      case SSEConstant.OpO2O.hungUp :
        this.onHungUp(pushRsp)
        break
      case SSEConstant.OpO2O.callBilling :
        this.onCallBilling(pushRsp)
        break
      case SSEConstant.OpO2O.remindRecharge :
        this.onRemindRecharge(pushRsp)
        break
      case SSEConstant.OpO2O.receiveHunt :        // 用户收到主播呼叫
        this.onReceiveHunt(pushRsp)
        break
      case SSEConstant.OpO2O.receiveStopHunt :    // 用户收到主播停止呼叫
        this.onReceiveStopHunt(pushRsp)
        break
      case SSEConstant.OpO2O.remindHuntRecharge : // 主播主动呼叫的电话过程中提醒用户充值
        this.onRemindHuntRecharge(pushRsp)
        break
    }
  }

  onUserCall(PPPushRsp) {
    log(this.cName, "onUserCall-- " + PPPushRsp.retCode)
    this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_USER_CALL, PPPushRsp.retCode)
  }

  onReceiveRefuse(PPPushRsp) {
    log(this.cName, "onReceiveRefuse-- " + PPPushRsp.retCode)
    this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_ANCHOR_REFUSE_CALL, PPPushRsp.retCode)
  }

  onUserEnterRoom(PPPushRsp) {
    log(this.cName, "onUserEnterRoom-- " + PPPushRsp.retCode)
    try {
      // let bean = JSON.parse(PPPushRsp.data)
      this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_USER_ENTER_ROOM, PPPushRsp.retCode, PPPushRsp.data)
    } catch (e) {
      loge(this.cName, 'onUserEnterRoom-e:' + e)
    }
  }

  onHungUp(PPPushRsp) {
    log(this.cName, "onHungUp-- " + PPPushRsp.retCode + ' ' + JSON.stringify(PPPushRsp.data))
    // var bean = null
    // try {
    //   bean = JSON.parse(PPPushRsp.data)
    // } catch (e) {
    // loge(this.cName,e)
    // }
    try {
      // showHangUp(PPPushRsp.retCode, PPPushRsp.data)
      this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_SHOW_CALL_END, PPPushRsp.retCode, PPPushRsp.data)
      this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_HUNG_UP_CALL, PPPushRsp.retCode, PPPushRsp.data)
    } catch (e) {
      loge(this.cName, 'onUserEnterRoom-e:' + e)
    }
  }

  onCallBilling(PPPushRsp) {
    log(this.cName, "onCallBilling-- " + PPPushRsp.retCode)
    // var bean = null
    // try {
    //   bean = JSON.parse(PPPushRsp.data)
    // } catch (e) {
    //   loge(this.cName,e)
    // }
    this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_CALL_BILLING, PPPushRsp.retCode, PPPushRsp.data)
  }

  onRemindRecharge(PPPushRsp) {
    log(this.cName, "onRemindRecharge-- " + PPPushRsp.retCode)
    this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_REMIND_RECHARGE)
  }

  /**
   * 用户收到主播呼叫
   */
  onReceiveHunt(PPPushRsp) {
    log(this.cName, "onReceiveHunt-- " + PPPushRsp.retCode)
    // var bean = null
    // try {
    //   bean = JSON.parse(PPPushRsp.data)
    // } catch (e) {
    //   loge(this.cName,e)
    // }
    this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_REMIND_RECHARGE, PPPushRsp.retCode, PPPushRsp.data)
  }

  /**
   * 用户收到主播停止呼叫
   */
  onReceiveStopHunt(PPPushRsp) {
    log(this.cName, "onReceiveStopHunt-- " + PPPushRsp.retCode)
    this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_RECEIVE_STOP_HUNT)
  }

  onRemindHuntRecharge(PPPushRsp) {
    log(this.cName, "onRemindHuntRecharge-- " + PPPushRsp.retCode)
    this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_RECEIVE_REMIND_HUNT_RECHARGE)
  }


}



// WEBPACK FOOTER //
// ./src/push/listener/SSEO2OListener.js